module.exports = __webpack_public_path__ + "img/import.f0a980c7.svg";